import {useEffect, useMemo, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {SoopInputBox, SoopSectionTitle, SoopSheetTitle} from '@soop-ui/soop-ui';
import {useSearchArea} from '@/hooks/help';
import Title from '@/components/help/common/Title';
import RecommendKeyword from '@/components/help/common/RecommendKeyword';
import {SEARCH_PLACEHOLDER} from '@/constants/help/search';
import styles from '@/components/help/pc/common/SearchArea/SearchArea.module.scss';
import mobileStyles from './SearchArea.module.scss';

const SearchArea = () => {
  const ref = useRef<HTMLInputElement>(null);
  const {inputValue, search, onChange, onKeyUp, onClear} = useSearchArea();
  const navigate = useNavigate();
  const {hash} = useLocation();
  const isSearchLayer = useMemo(() => {
    return hash === '#search';
  }, [hash]);

  const onFocus = () => {
    if (!isSearchLayer) {
      navigate(`#search`);
    }
  };

  useEffect(() => {
    // 새로고침하거나 #search로 진입하는 경우 hash 제거하여 본 페이지가 노출되도록 함
    if (window.location.hash === '#search') {
      window.location.hash = '';
      navigate('', {replace: true});
    }
  }, [navigate]);

  const SearchElement = isSearchLayer
    ? {
        wrapperStyle: mobileStyles.SearchWrapper,
        innerStyle: mobileStyles.inner,
        sheetTitle: (
          <SoopSheetTitle
            btnBack
            title='고객센터 검색'
            onBackClick={() => navigate(-1)}
            className={mobileStyles.SheetTitle}
          />
        ),
        keywordList: (
          <div className={mobileStyles.RecommendKeywordWrapper}>
            <SoopSectionTitle>
              <SoopSectionTitle.Title size='sm'>
                관련 키워드
              </SoopSectionTitle.Title>
            </SoopSectionTitle>
            <div className={mobileStyles.RecommendKeywordArea}>
              <RecommendKeyword align={isSearchLayer ? 'left' : 'center'} />
            </div>
          </div>
        ),
      }
    : {
        wrapperStyle: styles.SearchWrapper,
        innerStyle: styles.SearchArea,
        title: <Title title='무엇을 도와드릴까요?' icon />,
      };

  return (
    <div className={SearchElement.wrapperStyle}>
      {SearchElement.title}
      <div className={SearchElement.innerStyle}>
        {SearchElement.sheetTitle}
        <SoopInputBox
          ref={ref}
          className={styles.SearchBox}
          iconName='icoSearch'
          placeholder={SEARCH_PLACEHOLDER}
          size={48}
          onCustomButtonClick={search}
          value={inputValue}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onClear={onClear}
          onFocus={onFocus}
          autoComplete='off'
        />
        {SearchElement.keywordList}
      </div>
    </div>
  );
};

export default SearchArea;
